import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { finalize, forkJoin } from 'rxjs';
import { ProfesionService } from 'src/app/api/services/proffesion.service';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { ModalFormComponent } from 'src/app/shared/component/modal-form/modal-form.component';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import {
  FormFieldConfig,
  TableAction,
  TableColumn,
} from 'src/app/shared/model/admin';
import { Profession } from 'src/app/shared/model/profession';
import { ToastService } from 'src/app/shared/service/toast.service';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-professions',
  imports: [
    CommonModule,
    ModalFormComponent,
    TableGenericComponent,
    LoadingComponent,
  ],
  templateUrl: './professions.component.html',
  styles: ``,
})
export class ProfessionsComponent {
  mostrarModalAgregar: boolean = false;
  mostrarModalEditar: boolean = false;
  loadingAgregar: boolean = false;
  loadingEditar: boolean = false;
  loadingProfessions: boolean = false;
  editarSeleccionada?: any;

  professions: Profession[] = [];

  formAgregar!: FormGroup;
  formEditar!: FormGroup;

  columns: TableColumn[] = [
    { header: 'Nombre', field: 'name' },
    { header: 'Estado', field: 'state' },
  ];
  actions: TableAction[] = ['edit'];

  fieldsAgregar: FormFieldConfig[] = [
    {
      name: 'name',
      label: 'Nombre',
      placeholder: 'Nombre de la profesión',
    },
  ];
  fieldsEditar: FormFieldConfig[] = [
    {
      name: 'name',
      label: 'Nombre',
      placeholder: 'Nombre de la profesión',
    },
    {
      name: 'state',
      label: 'Estado',
      type: 'select',
      options: [
        { label: 'Activo', value: 'activo' },
        { label: 'Inactivo', value: 'inactivo' },
      ],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private profesionService: ProfesionService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForms();
    this.cargarProfessions();
  }

  private initForms(): void {
    this.formAgregar = this.fb.group({ name: ['', Validators.required] });
    this.formEditar = this.fb.group({
      name: ['', Validators.required],
      state: ['', Validators.required],
    });
  }

  private cargarProfessions(): void {
    this.loadingProfessions = true;
    this.profesionService
      .getAll()
      .pipe(
        handleApiError(this.toastService, MESSAGES.PROFESSION.GET_ALL_ERROR),
        finalize(() => (this.loadingProfessions = false))
      )
      .subscribe((res: any) => {
        this.professions = res.dto?.professions || [];
      });
  }

  openModal(type: 'add' | 'edit', profession?: Profession): void {
    this.mostrarModalAgregar = false;
    this.mostrarModalEditar = false;
    this.editarSeleccionada = undefined;

    if (type === 'add') {
      this.formAgregar.reset();
      this.mostrarModalAgregar = true;
      return;
    }

    if (type === 'edit' && profession) {
      this.editarSeleccionada = profession;
      this.formEditar.setValue({
        name: profession.name,
        state: profession.state,
      });
      this.mostrarModalEditar = true;
    }
  }

  crearProfession(): void {
    if (this.formAgregar.invalid) {
      this.formAgregar.markAllAsTouched();
      return;
    }

    this.loadingAgregar = true;
    const { name } = this.formAgregar.value;

    this.profesionService
      .createProfesion(name)
      .pipe(
        handleApiError(this.toastService, MESSAGES.PROFESSION.CREATE_ERROR),
        finalize(() => (this.loadingAgregar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.PROFESSION.CREATE_SUCCESS,
        ]);
        this.cargarProfessions();
        this.mostrarModalAgregar = false;
      });
  }

  actualizarProfession(): void {
    if (this.formEditar.invalid || !this.editarSeleccionada) {
      this.formEditar.markAllAsTouched();
      return;
    }

    this.loadingEditar = true;
    const { name, state } = this.formEditar.value;
    const idProfession = this.editarSeleccionada.idProfession;

    const nombre$ = this.profesionService.updateProfesion(idProfession, name);
    const estado$ = this.profesionService.updateStateByIdProfession(
      idProfession,
      state
    );

    forkJoin([nombre$, estado$])
      .pipe(
        handleApiError(this.toastService, MESSAGES.PROFESSION.UPDATE_ERROR),
        finalize(() => (this.loadingEditar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.PROFESSION.UPDATE_SUCCESS,
        ]);
        this.cargarProfessions();
        this.mostrarModalEditar = false;
      });
  }
}
